import { render, staticRenderFns } from "./PerfumeCard.vue?vue&type=template&id=2a0ba2d3&scoped=true"
import script from "./PerfumeCard.vue?vue&type=script&lang=js"
export * from "./PerfumeCard.vue?vue&type=script&lang=js"
import style0 from "./PerfumeCard.vue?vue&type=style&index=0&id=2a0ba2d3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ba2d3",
  null
  
)

export default component.exports